
import React, { useState, useEffect, useCallback } from 'react';
import { callApi } from './api'; // Importer den nye hjelpefunksjonen
import UserTable from './UserTable';
import EditUserForm from './EditUserForm';
import CreateUserForm from './CreateUserForm';
import UserGateManager from './UserGateManager';

function ManagedUserView({ admin, onBack }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [managingAccessForUser, setManagingAccessForUser] = useState(null);

  // The L2 admin object contains the ownerId we need
  const ownerId = admin?.customClaims?.ownerId;

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Bruk den nye callApi-funksjonen
      const result = await callApi('listUsersByAdminV2', { adminUid: admin.uid });
      setUsers(result.users);
    } catch (err) {
      setError(`Kunne ikke hente brukere for ${admin.displayName}. ` + err.message);
    } finally {
      setLoading(false);
    }
  }, [admin]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleFormFinished = () => {
    setEditingUser(null);
    setShowCreateForm(false);
    setManagingAccessForUser(null);
    fetchUsers();
  };

  return (
    <div>
      <button onClick={onBack} style={{ marginBottom: '20px' }}>&larr; Tilbake til admin-listen</button>
      <h3>Brukere for {admin.displayName || admin.email}</h3>

      {!showCreateForm && !editingUser && !managingAccessForUser && (
        <button onClick={() => setShowCreateForm(true)} style={{ margin: '20px 0' }}>
          + Opprett ny bruker
        </button>
      )}

      {showCreateForm && (
        <CreateUserForm 
          onUserCreated={handleFormFinished}
          onCancel={() => setShowCreateForm(false)}
          createFunction="createUserV2"
          contextualAdminUid={admin.uid}
        />
      )}

      {loading && <p>Laster brukere...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && (
        <UserTable 
          users={users} 
          onEditUser={setEditingUser}
          onManageAccess={setManagingAccessForUser}
          isLevel1List={true}
        />
      )}

      {editingUser && (
        <EditUserForm 
          user={editingUser} 
          onFinished={handleFormFinished} 
        />
      )}

      {managingAccessForUser && (
        <UserGateManager 
            user={managingAccessForUser}
            ownerId={ownerId}
            onFinished={handleFormFinished}
        />
      )}
    </div>
  );
}

export default ManagedUserView;
